"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const types = __importStar(require("./types"));
exports.init = () => {
    return {
        type: types.INIT,
    };
};
exports.addSpot = (spot) => {
    return {
        payload: {
            spot,
        },
        type: types.ADD_SPOT,
    };
};
exports.panTo = (spot) => {
    return {
        payload: {
            spot,
        },
        type: types.PAN_TO,
    };
};
exports.filter = (visibleGenre) => {
    return {
        payload: {
            visibleGenre,
        },
        type: types.FILTER,
    };
};
exports.reset = () => {
    return {
        type: types.RESET,
    };
};
